// What every layout is built from. A layout's theme gives five colours (see
// render/colourways.js): paper, ink, accent, pop and on. The bold layouts
// wear the accent as their ground, with their words in on.
import { label, widthOf } from '../../kit'

export const base = (env) => ({ fr: env.frame, c: env.post.content || {}, k: env.theme.c, w: widthOf(env.frame) })

// The ground, and the colour words take on it
export const ground = (p, env, dark) => {
  const { fr, k } = base(env)
  p.rect(0, 0, fr.W, fr.H, dark ? k.accent : k.paper)
  return dark ? k.on : k.ink
}

// A serif for quotes, notes and tickets: the headline's own when it's a
// serif, else Fraunces
export const serifFont = (env) => (env.theme.family.italic ? env.theme.family.display : 'fraunces')
export const serif = (env, colour, size, extra = {}) => ({
  font: serifFont(env), weight: 400, size, minSize: Math.max(30, Math.round(size * 0.55)), lh: 1.14, color: colour, accentOn: false, ...extra,
})
// A typewriter face, for receipts and tickets
export const mono = (colour, size, extra = {}) => ({
  font: 'courierPrime', weight: 400, size: Math.max(30, size), minSize: 30, lh: 1.2, color: colour, ...extra,
})
// Heavy graphic words and numbers ("NEW", a rating, a tip's number)
export const heavy = (colour, size, extra = {}) => ({
  font: 'archivoBlack', weight: 400, size, minSize: Math.max(60, Math.round(size * 0.5)), lh: 0.92, tracking: -0.02, color: colour, ...extra,
})

// The small line that rests just above the footer
export const detailLine = (env, fr, text, colour, { slot = 'detail', gap = 40 } = {}) => (text ? {
  bottom: true,
  gap,
  draw: (pp, y) => pp.text(text, { ...label(env, colour), x: fr.left, y, w: widthOf(fr), maxLines: 2, slot }).bottom,
} : null)

// A filled triangle (the teeth of a receipt, a speech bubble's tail)
export const triangle = (pp, points, colour) => {
  if (pp.isDry) return
  const { ctx } = pp
  ctx.save()
  ctx.fillStyle = colour
  ctx.beginPath()
  points.forEach(([x, y], i) => (i ? ctx.lineTo(x, y) : ctx.moveTo(x, y)))
  ctx.closePath()
  ctx.fill()
  ctx.restore()
}

// A stroked line through points (a tick)
export const polyline = (pp, points, colour, width = 4) => {
  if (pp.isDry) return
  const { ctx } = pp
  ctx.save()
  ctx.strokeStyle = colour
  ctx.lineWidth = width
  ctx.lineCap = 'round'
  ctx.lineJoin = 'round'
  ctx.beginPath()
  points.forEach(([x, y], i) => (i ? ctx.lineTo(x, y) : ctx.moveTo(x, y)))
  ctx.stroke()
  ctx.restore()
}

// The review's stars, 1 to 5, or none when there's no rating
export const starsOf = (c) => {
  const n = Math.round(Number(c.rating))
  return n >= 1 && n <= 5 ? n : 0
}

// A first name, as a design's headline says it
export const nameOf = (c) => String(c.name || '').trim()
export const lines = (list, n = 3) => (Array.isArray(list) ? list : []).map(s => String(s || '').trim()).filter(Boolean).slice(0, n)
export const pairs = (list, n = 3) => (Array.isArray(list) ? list : []).filter(x => x && (String(x.q || '').trim() || String(x.a || '').trim())).slice(0, n)
